import React, {useRef} from "react";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
import "assets/scss/material-kit-react.scss?v=1.9.0";
import LandingPage from "./views/LandingPage.js";
import LoginPage from "./views/LoginPage.js";
import PrivacyPolicy from "./views/PrivacyPolicy.js";
import AuthLoading from './views/AuthLoading';
import { Provider } from "react-redux";
import ProtectedRoute from './views/ProtectedRoute';
import MyProfile from './views/MyProfile';
import BookingHistory from './views/BookingHistory';
import DeliveryHistory from './views/DeliveryHistory';
import CustomerInvoices from './views/CustomerInvoices';
import InvoicesHistory from './views/InvoicesHistory';
import Dashboard from './views/Dashboard';
import CarTypes from './views/CarTypes';
import PhoneDelivery from './views/PhoneDelivery';
import NewDelivery from './views/NewDelivery';
import Promos from './views/Promos';
import Dispatchers from './views/Dispatchers';
import Drivers from './views/Drivers';
import FleetAdmins from './views/FleetAdmins';
import Notifications from './views/Notifications';
import DriverEarning from './views/DriverEarning';
import Earningreports from './views/Earningreports';
import ProfileWallet from './views/ProfileWallet';
import Settings from './views/Settings';
import Withdraws from './views/Withdraws';
import CancellationReasons from './views/CancellationReasons';
import RegisterPage from './views/RegisterPage';
import AddMoney from "./views/AddMoney";
import { Google_Map_API_Key } from 'config';
import WhatsApp from 'components/WhatsApp';

import {
  store,
  FirebaseProvider
} from "common";

import { features } from 'config';

function loadScript(src, position, id) {
  if (!position) {
    return;
  }

  const script = document.createElement('script');
  script.setAttribute('async', '');
  script.setAttribute('id', id);
  script.src = src;
  position.appendChild(script);
}

var hist = createBrowserHistory();

function App() {
  const loaded = useRef(false);
  if (typeof window !== 'undefined' && !loaded.current && !window.google) {
    if (!document.querySelector('#google-maps')) {
      loadScript(
        'https://maps.googleapis.com/maps/api/js?key=' + Google_Map_API_Key['web'] + '&libraries=geometry,drawing,places',
        document.querySelector('head'),
        'google-maps',
      );
    }
    loaded.current = true;
  }

  return (
    <Provider store={store}>
      <FirebaseProvider>
        <AuthLoading>
          <Router history={hist}>
            <Switch>
              <ProtectedRoute exact component={BookingHistory} path="/bookings" permit={"dispatcher,admin,driver,fleetadmin"} />
              <ProtectedRoute exact component={DeliveryHistory} path="/userbookings" permit={"admin,dispatcher,driver"} />
              <ProtectedRoute exact component={InvoicesHistory} path="/admininvoices" permit={"admin,dispatcher,driver"} />
              <ProtectedRoute exact component={CustomerInvoices} path="/userinvoices" permit={"admin,dispatcher,driver"} />
              <ProtectedRoute exact component={MyProfile} path="/profile" permit={"dispatcher,admin,driver,fleetadmin"} />
              <ProtectedRoute exact component={Dashboard} path="/dashboard" permit={"admin,fleetadmin"} />
              <ProtectedRoute exact component={CarTypes} path="/cartypes" permit={"admin"} />
              <ProtectedRoute exact component={CancellationReasons} path="/cancelreasons" permit={"admin"} />
              <ProtectedRoute exact component={PhoneDelivery} path="/phonedelivery" permit={"admin"} />
              <ProtectedRoute exact component={Promos} path="/promos" permit={"admin"} />
              <ProtectedRoute exact component={Dispatchers} path="/dispatchers" permit={"admin"} />
              <ProtectedRoute exact component={Drivers} path="/drivers" permit={"admin,fleetadmin"} />
              <ProtectedRoute exact component={FleetAdmins} path="/fleetadmins" permit={"admin"} />
              <ProtectedRoute exact component={DriverEarning} path="/driverearning" permit={"admin,fleetadmin"} />
              <ProtectedRoute exact component={Notifications} path="/notifications" permit={"admin"} />
              <ProtectedRoute exact component={Earningreports} path="/earningreports" permit={"admin,fleetadmin"} />
              <ProtectedRoute exact component={NewDelivery} path="/newdelivery" permit={"dispatcher, admin, driver, fleetadmin"} />
              <ProtectedRoute exact component={ProfileWallet} path="/profilewallet" permit={"dispatcher, driver"} />
              <ProtectedRoute exact component={AddMoney} path="/addtowallet" permit={"admin"} />
              <ProtectedRoute exact component={Withdraws} path="/withdraws" permit={"admin"} />
              <ProtectedRoute exact component={Settings} path="/settings" permit={"admin"} />
              <Route path="/privacy-policy" component={PrivacyPolicy} />
              {features.WithWebsitePages ?
                <Route path="/register" component={RegisterPage} />
                : null}
              {features.WithWebsitePages ?
                <Route path="/login" component={LoginPage} />
                : null}
              {features.WithWebsitePages ?
                <Route path="/" component={LandingPage} />
                :
                <Route path="/" component={LoginPage} />
              }
            </Switch>
          </Router>
          <WhatsApp />
        </AuthLoading>
      </FirebaseProvider>
    </Provider>
  );
}

export default App;